/*jshint esversion: 8 */
import React from 'react';
import './App.css';
import Main from './components/Main';
import Start from './components/Start';

function App() {
  return (
    <div className="App">
      <Main />
      <Start />
    </div>
  );
}

export default App;
